document.addEventListener('DOMContentLoaded', () => {
    // 1. Sticky Header Effect
    const header = document.querySelector('header');

    // 2. Advanced Scroll Animations (Muteza style)
    
    // Setup observer with a threshold that works well for large elements
    const observerOptions = {
        root: null,
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
    };

    const scrollObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                // Unobserve to run animation only once
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // Observe text reveals
    document.querySelectorAll('.reveal-text, .fade-in, .img-reveal').forEach(el => {
        scrollObserver.observe(el);
    });

    // 3. Subtle Image Parallax on Scroll
    // This mimics Locomotive without hijacking scroll
    const parallaxImages = document.querySelectorAll('img[data-scroll]');
    
    window.addEventListener('scroll', () => {
        const scrolled = window.pageYOffset;
        
        parallaxImages.forEach(img => {
            const speed = 0.05; // Subtle movement
            // Only animate if image is in viewport
            const rect = img.getBoundingClientRect();
            if (rect.top <= window.innerHeight && rect.bottom >= 0) {
                const yPos = -(scrolled * speed);
                img.style.transform = `translate3d(0, ${yPos}px, 0) scale(1.05)`;
            }
        });
    });

    // 4. Smooth Scrolling for Anchor Links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const targetId = this.getAttribute('href');
            if (targetId === '#') return;
            
            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                e.preventDefault();
                document.querySelector(".header__icon.header__icon--menu").click();
                const headerHeight = header.offsetHeight;
                const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;
                
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
    
    // Trigger animations for elements already in viewport on load
    setTimeout(() => {
        document.querySelectorAll('.reveal-text, .fade-in, .img-reveal').forEach(el => {
            const rect = el.getBoundingClientRect();
            if (rect.top < window.innerHeight) {
                el.classList.add('is-visible');
            }
        });
    }, 100);

    document.addEventListener('shopify:section:load', () => {
        document.querySelectorAll('.reveal-text, .fade-in, .img-reveal').forEach(el => {
            scrollObserver.observe(el);
        });
    });
});